import type { KeyboardEvent } from "react";

export function boolNegate(bool: boolean) {
	return !bool;
}

/**
 * HTML boolean attributes are either defined or undefined.
 */
export function toBoolAttr(attr: unknown) {
	return attr ? "" : undefined;
}

/**
 * A type guard for detecting abort errors.
 * Abort errors are {@link Error} instances whose {@link Error.name} is `'AbortError'`.
 * For reliable detection, do not modify abort error instances' names.
 */
export function isAbortError(error: unknown): error is Error {
	return error instanceof Error && error.name === "AbortError";
}

/**
 * Stops ALK Maps from capturing arrow key presses.
 * Also blurs the active element if the escape key is pressed.
 */
export function stopArrowKeyPropagation(e: KeyboardEvent) {
	switch (e.key) {
		case "ArrowUp":
		case "ArrowDown":
		case "ArrowLeft":
		case "ArrowRight":
			e.stopPropagation();
			break;
		case "Escape":
			(document.activeElement as HTMLElement | SVGElement | null)?.blur();
	}
}
